import React from 'react';
import ReactDOM from 'react-dom';
import Router from './components';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react'
import history from './lib/history';
import { registerAesKey } from './lib/crypto';
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "./css/global.css";
import "./css/index.css";

registerAesKey(); // intiate the bad ass person in the world

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <Router />
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

//serviceWorker.register();